/**
 * custom_product_preview_customizer_v2.js
 * ─────────────────────────────────────
 * Fixed version — resolves:
 *   1. Review screen now only shows the side(s) with actual content
 *   2. "Also add back design?" button appears when only front is customized
 *   3. Proper content detection using _hasContent() helper
 *
 * KEY FIX: _hasContent() now checks the CORRECT elements:
 *   - .front_uploaded_content / .back_uploaded_content  (text typed by user)
 *   - .front_image_url / .back_image_url  (gallery image selection)
 *   - #uploaded-image / #buploaded-image  (uploaded image)
 *   - .front_image .logo_img_gal / .back_image .logo_img_gal  (gallery logo)
 *
 * Previously it was checking .front_image .cstm_textup which gets cleared
 * on popup open and is empty at Review time.
 */

/* ── Helpers ──────────────────────────────────────────────────────── */

/**
 * Returns true when the given side actually has user content
 * (text, gallery logo, gallery image, or uploaded image).
 *
 * Checks the hidden content-holder spans in theme.liquid that persist
 * across the popup lifecycle, NOT the visual overlay elements which
 * may be cleared/reset during tab switching.
 */
function _hasContent(side) {
  var isFront = (side === 'front');

  /* 1. Text content — stored in hidden span by the keyup handler */
  var uploadedContentSel = isFront ? '.front_uploaded_content' : '.back_uploaded_content';
  var txt = $.trim($(uploadedContentSel).text());
  if (txt.length > 0 && txt !== 'N/A') return true;

  /* 2. Also check .cstm_textup as a fallback (may have content from gallery+text combo) */
  var prefix = isFront ? '.front_image' : '.back_image';
  var cstmTxt = $.trim($(prefix + ' .cstm_textup').text());
  if (cstmTxt.length > 0) return true;

  /* 3. Gallery logo image */
  var galSrc = $(prefix + ' img.logo_img_gal').attr('src');
  if (galSrc && galSrc !== '') return true;

  /* 4. Gallery image URL (texture) */
  var urlHolder = isFront ? '.front_image_url' : '.back_image_url';
  var imgUrl = $.trim($(urlHolder).text());
  if (imgUrl.length > 0 && imgUrl !== 'N/A') return true;

  /* 5. Uploaded image */
  var uploadId = isFront ? '#uploaded-image' : '#buploaded-image';
  var uploadSrc = $(uploadId).attr('src');
  if (uploadSrc && uploadSrc !== '' && uploadSrc !== undefined) return true;

  /* 6. Uploaded image via .uploadingimg */
  var uploadImgSrc = $(prefix + ' .uploadingimg').attr('src');
  if (uploadImgSrc && uploadImgSrc !== '') return true;

  return false;
}

/**
 * Show/hide front and back images on the review screen based on content.
 * Returns an object { front: bool, back: bool } indicating which sides are shown.
 */
function _showSides() {
  var hasFront = _hasContent('front');
  var hasBack  = _hasContent('back');

  console.log('[_showSides] hasFront:', hasFront, 'hasBack:', hasBack);
  console.log('[_showSides] front_uploaded_content:', JSON.stringify($.trim($('.front_uploaded_content').text())));
  console.log('[_showSides] back_uploaded_content:', JSON.stringify($.trim($('.back_uploaded_content').text())));
  console.log('[_showSides] front_image_url:', JSON.stringify($.trim($('.front_image_url').text())));
  console.log('[_showSides] back_image_url:', JSON.stringify($.trim($('.back_image_url').text())));

  if (hasFront && hasBack) {
    /* Both sides — show both at 50% width each */
    $(".left_image_customize").addClass("both_active");
    $(".front_image").addClass("active").removeClass("hide");
    $(".back_image").addClass("active").removeClass("hide");
    $(".edit_front_tab").removeClass("hide");
    $(".edit_back_tab").removeClass("hide");
    /* Hide the "also add back" button if it exists */
    $(".also_add_back_btn").addClass("hide");
  } else if (hasFront && !hasBack) {
    /* Front only — show front full width, hide back */
    $(".left_image_customize").removeClass("both_active");
    $(".front_image").addClass("active").removeClass("hide");
    $(".back_image").removeClass("active").addClass("hide");
    $(".edit_front_tab").removeClass("hide");
    $(".edit_back_tab").addClass("hide");
    /* Show "also add back design?" button */
    $(".also_add_back_btn").removeClass("hide");
  } else if (!hasFront && hasBack) {
    /* Back only — show back full width, hide front */
    $(".left_image_customize").removeClass("both_active");
    $(".front_image").removeClass("active").addClass("hide");
    $(".back_image").addClass("active").removeClass("hide");
    $(".edit_front_tab").addClass("hide");
    $(".edit_back_tab").removeClass("hide");
    $(".also_add_back_btn").addClass("hide");
  } else {
    /* Neither side has content — shouldn't happen at Review time, but fallback to showing both */
    console.warn('[_showSides] WARNING: No content detected on either side. Falling back to show both.');
    $(".left_image_customize").addClass("both_active");
    $(".front_image").addClass("active").removeClass("hide");
    $(".back_image").addClass("active").removeClass("hide");
    $(".edit_front_tab").removeClass("hide");
    $(".edit_back_tab").removeClass("hide");
    $(".also_add_back_btn").addClass("hide");
  }

  return { front: hasFront, back: hasBack };
}

/* ── Inject "Also add back design?" button into the DOM ──────────── */
$(document).ready(function() {
  /* Only inject if the popup exists and the button doesn't already exist */
  if ($('.popup_pd_customizer').length && !$('.also_add_back_btn').length) {
    /* Insert after the edit tabs, inside .button_tabs */
    var btnHtml = '<button class="also_add_back_btn tab_items btn btn--primary btn--small hide" type="button" style="width:100%;max-width:300px;margin:5px auto 0;background-color:#fff;color:#262626;border:2px dashed #262626;font-size:13px;letter-spacing:1px;padding:10px 15px;cursor:pointer;">+ ALSO ADD BACK DESIGN</button>';
    $('.button_tabs').append(btnHtml);
  }
});

/* ── "Also add back design?" click handler ───────────────────────── */
$(document).on('click', '.also_add_back_btn', function() {
  /* Switch to back tab editing mode */
  $(this).addClass('hide');

  /* Hide the review state */
  $(".addtocart_box").addClass("hide");
  $(".left_image_customize").removeClass("both_active");
  $(".front_image").removeClass("active");
  $(".back_image").removeClass("active");

  /* Show back tab as active, front tab as inactive */
  $(".front_tab").removeClass("hide").removeClass("active");
  $(".back_tab").removeClass("hide").addClass("active");
  $(".edit_front_tab").addClass("hide");
  $(".edit_back_tab").addClass("hide");

  /* Re-show the customize selection menu */
  $(".customize-selection").removeClass("hide");

  /* Re-show the text design section controls if text was the active mode */
  if ($(".inner_text_design_content")[0]) {
    $(".inner_text_design_content").removeClass("active");
    $(".back_text").removeAttr("style");
    $(".text_font_section").removeAttr("style");
  }

  /* Show clear/preview buttons */
  $(".text_nav_design .clear_btn").removeClass("hide").removeAttr("disabled");
  $(".text_nav_design .preview_btn").removeClass("hide");

  /* Re-enable the back tab */
  $(".back_tab").removeAttr("disabled");
});


/* ── Upload preview button ───────────────────────────────────────── */
$(document).on("click", ".upload_nav_design .preview_btn", function () {
  $("#design-text").val("");
  $(".resizable").css("outline", "unset");
  $(this).addClass("hide");
  $(".upload_nav_design .clear_btn").addClass("hide");
  $(".upload_nav_design .addtocart_box").removeClass("hide");

  if ($(".selected_design_box.active")[0]) {
    $(".selected_design_box.active .inner_selected_design").css("display", "none");
    $(".color_customize_variants").css("display", "none");
  }
  if ($(".inner_logo_designs_content.active")[0]) {
    $(".inner_logo_designs_content.active").css("display", "none");
    $(".color_customize_variants").css("display", "none");
  }
  if ($(".inner_text_design_content.active")[0]) {
    $(".inner_text_design_content.active").css("display", "none");
    $(".color_customize_variants").css("display", "none");
  }

  /* Hide front/back tabs, show edit tabs */
  $(".front_tab").addClass("hide");
  $(".back_tab").addClass("hide");

  /* Use smart side detection */
  var sides = _showSides();

  /* Show text overlays for sides with content */
  if (sides.front) {
    $(".front_image .text_uploaded").removeClass("hide").addClass("active");
  }
  if (sides.back) {
    $(".back_image .text_uploaded").removeClass("hide").addClass("active");
  }

  /* Handle uploaded images */
  var frontimgg = $(".front_image").attr("data-src");
  var backimmg = $(".back_image").attr("data-src");
  $(".front_image img.uploadingimg").attr("src", frontimgg);
  $(".back_image img.uploadingimg").attr("src", backimmg);

  var front_logoimg = $(".front_image .logo_img_gal").attr("src");
  var back_logoimg = $(".back_image .logo_img_gal").attr("src");
  var back = $(".back_image .uploadingimg").attr("src");
  var front = $(".front_image .uploadingimg").attr("src");

  if (back == undefined) {
    $(".back_image .resizable").removeClass("active");
  } else {
    $(".back_image .resizable").addClass("active");
  }
  if (front == undefined) {
    if ($(".front_image .logo_img.hide")[0]) {
      $(".front_image .text_uploaded").removeClass("hide");
    }
    $(".front_image .resizable").removeClass("active");
    var frontremove = setInterval(function () {
      $(".front_image .resizable").removeClass("active");
      clearInterval(frontremove);
    }, 500);
  } else {
    if ($(".front_image .resizable.hide")[0]) {
      $(".front_image .resizable").removeClass("active");
    } else {
      $(".front_image .resizable").addClass("active");
    }
  }

  if (front_logoimg === undefined || front_logoimg == "") {
    if ($(".front.img_box.active")[0]) {
      $(".front_image").addClass("active");
      $(".front_image .resizable").removeClass("hide").addClass("active");
      $(".front_image .logo_img").addClass("hide").removeClass("active");
    }
  }

  if (back_logoimg === undefined || back_logoimg == "") {
    if ($(".back_image.img_box.active")[0]) {
      $(".back_image").addClass("active");
      $(".back_image .resizable").removeClass("hide").addClass("active");
      $(".back_image .logo_img").addClass("hide").removeClass("active");
      var removea = setInterval(function () {
        if ($(".back_image .resizable.active")[0]) {
          clearInterval(removea);
        } else {
          $(".back_image .resizable").addClass("active");
        }
      }, 1000);
    }
  }

  var front_text = $(".front_image .cstm_textup").html();
  var back_text = $(".back_image .cstm_textup").html();

  if (front_text != "" && front_logoimg != undefined) {
    $(".front_image").addClass("both_textactive");
  } else if (front_text != "" && front != undefined) {
    $(".front_image").addClass("both_textactive");
  } else {
    $(".front_image").removeClass("both_textactive");
  }

  var fronturl = $(".front_image_url").html();
  if (fronturl != "" && fronturl != "N/A") {
    $(".front_image").addClass("both_textactive");
  } else {
    $("#inverseCheckbox").prop("checked", false);
    $(".front_image").removeClass("both_textactive");
  }

  var backurl = $(".back_image_url").html();
  if (backurl != "" && backurl != "N/A") {
    $(".back_image").addClass("both_textactive");
  } else {
    $(".back_image").removeClass("both_textactive");
    $("#backinverseCheckbox").prop("checked", false);
  }
});

/* ── Text preview button (MAIN FIX) ─────────────────────────────── */
$(document).on(
  "click",
  ".nav_design_buttons.text_nav_design .preview_btn",
  function () {
    var currentfont = $(".font_items.active").attr("data-font");
    if ($(".front_text_preview.active")[0]) {
      $(".front_image").removeClass(
        "cstm_font_Roboto cstm_font_Socialist cstm_font_Manderley cstm_font-Crosterian cstm_font_Whiphand"
      );
      $(".front_image").addClass("cstm_font_" + currentfont);
    }
    if ($(".back_text_preview.active")[0]) {
      $(".back_image").removeClass(
        "cstm_font_Roboto cstm_font_Socialist cstm_font_Manderley cstm_font-Crosterian cstm_font_Whiphand"
      );
      $(".back_image").addClass("cstm_font_" + currentfont);
    }

    /* Hide this button and the clear button */
    $(this).addClass("hide");
    $(".text_nav_design .clear_btn").addClass("hide");

    /* Hide text previews */
    $(".front_text_preview").removeClass("active").addClass("hide");
    $(".back_text_preview").removeClass("active").addClass("hide");

    /* Hide text editing UI */
    $(".back_text").css("display", "none");
    $(".text_font_section").css("display", "none");

    /* Hide front/back design tabs */
    $(".front_tab").addClass("hide");
    $(".back_tab").addClass("hide");

    /* Show the Add to Cart box */
    $(".text_nav_design .addtocart_box").removeClass("hide");

    /* ── SMART SIDE DETECTION ── */
    var sides = _showSides();

    /* Read content for additional logic */
    var backhtml = $(".back_image .cstm_textup").html();
    var fronthtml = $(".front_image .cstm_textup").html();
    var logofront = $(".front_image img.logo_img_gal").attr("src");
    var logoback = $(".back_image img.logo_img_gal").attr("src");
    var uploadlogofront = $("#uploaded-image").attr("src");
    var uploadlogoback = $("#buploaded-image").attr("src");

    /* Show text overlays for sides with content */
    if (sides.front) {
      $(".front_image .text_uploaded").removeClass("hide").addClass("active");

      /* Check if front also has a logo (both_textactive) */
      if (fronthtml != "" && fronthtml != " " && logofront && logofront != "") {
        $(".front_image").addClass("both_textactive");
      }
      if (fronthtml != "" && fronthtml != " " && uploadlogofront != undefined) {
        $(".front_image").addClass("both_textactive");
      }
    }

    if (sides.back) {
      $(".back_image .text_uploaded").removeClass("hide").addClass("active");

      if (backhtml != "" && backhtml != " " && logoback && logoback != "") {
        $(".back_image").addClass("both_textactive");
      }
      if (backhtml != "" && backhtml != " " && uploadlogoback != undefined) {
        $(".back_image").addClass("both_textactive");
      }
    }

    /* Handle logo display for visible sides */
    if (sides.back) {
      if (logoback == "" || logoback == undefined) {
        $(".back_image .resizable").removeClass("hide").addClass("active");
        $(".back_image .logo_img").addClass("hide").removeClass("active");
        $(".back_image .text_uploaded").removeClass("hide").addClass("active");
      } else {
        $(".back_image .resizable").removeClass("active").addClass("hide");
        $(".back_image .logo_img").addClass("active").removeClass("hide");
        $(".back_image .text_uploaded").removeClass("hide").addClass("active");
      }
    }

    if (sides.front) {
      if (logofront == "" || logofront == undefined) {
        $(".front_image .resizable").removeClass("hide").addClass("active");
        $(".front_image .logo_img").addClass("hide").removeClass("active");
        $(".front_image .text_uploaded").removeClass("hide").addClass("active");
      } else {
        $(".front_image .resizable").removeClass("active").addClass("hide");
        $(".front_image .logo_img").addClass("active").removeClass("hide");
        $(".front_image .text_uploaded").removeClass("hide").addClass("active");
      }
    }

    /* Image URL checks */
    var fronturl = $(".front_image_url").html();
    if (fronturl != "" && fronturl != "N/A") {
      $(".front_image").addClass("both_textactive");
    } else {
      $("#inverseCheckbox").prop("checked", false);
      $(".front_image").removeClass("both_textactive");
    }

    var backurl = $(".back_image_url").html();
    if (backurl != "" && backurl != "N/A") {
      $(".back_image").addClass("both_textactive");
    } else {
      $(".back_image").removeClass("both_textactive");
      $("#backinverseCheckbox").prop("checked", false);
    }

    /* Size classes */
    var front_size = $(".front_image").attr("data-size");
    var back_size = $(".back_image").attr("data-size");
    $(".front_image").removeClass(
      "cstm_size_0 cstm_size_1 cstm_size_2 cstm_size_3 cstm_size_4 cstm_size_5 cstm_size_6 cstm_size_7 cstm_size_8 cstm_size_9 cstm_size_10 cstm_size_11 cstm_size_12"
    );
    $(".back_image").removeClass(
      "cstm_size_0 cstm_size_1 cstm_size_2 cstm_size_3 cstm_size_4 cstm_size_5 cstm_size_6 cstm_size_7 cstm_size_8 cstm_size_9 cstm_size_10 cstm_size_11 cstm_size_12"
    );
    $(".front_image").addClass("cstm_size_" + front_size);
    $(".back_image").addClass("cstm_size_" + back_size);
  }
);

/* ── Gallery preview buttons ─────────────────────────────────────── */
$(document).on("click", ".gallery_nav_design .preview_btn", function () {
  $(this).addClass("hide");
  $(".inner_gallerry_wraper.animal_gallery").removeClass("hide");
  $(".inner_gallerry_wraper.sports_gallery").removeClass("hide");
  $(".inner_gallerry_wraper.line_gallery").removeClass("hide");
  $(".inner_gallerry_wraper.nature_gallery").removeClass("hide");
  $(".inner_gallerry_wraper.weekend_gallery").removeClass("hide");
  $(".inner_gallerry_wraper.family_gallery").removeClass("hide");
  $(".inner_gallerry_wraper.travel_gallery").removeClass("hide");
  $(".inner_gallerry_wraper.pets_gallery").removeClass("hide");
  $('.pets_dogs').addClass("hide");
  $('.pets_cats').addClass("hide");
  $('.dogs').addClass("hide");
  $('.cats').addClass("hide");
  $('.family').addClass("hide");
  $('.back_dog').addClass("hide");
  $('.back_cats').addClass("hide");
  $(".back_pets").addClass("hide");

  $(".back_logo.back_btn").removeClass("hide");
  $(".back_animal.back_inner").addClass("hide");
  $(".back_sports.back_inner").addClass("hide");
  $(".back_lineart.back_inner").addClass("hide");
  $(".back_nature.back_inner").addClass("hide");
  $(".back_weekend.back_inner").addClass("hide");
  $(".back_family.back_inner").addClass("hide");
  $(".back_nature_travel.back_inner").addClass("hide");

  /* Hide front/back tabs */
  $(".front_tab").addClass("hide");
  $(".back_tab").addClass("hide");

  $(".back_logo").css("display", "flex");
  $(".logos_content").css("display", "none");
  $(".logo_gallery").css("display", "none");
  $(".gallery_nav_design .clear_btn").addClass("hide");
  $(".gallery_nav_design .addtocart_box").removeClass("hide");

  /* ── SMART SIDE DETECTION ── */
  var sides = _showSides();

  var galtextback = $(".back_image .cstm_textup").html();
  var galtextfront = $(".front_image .cstm_textup").html();
  var logoafront = $(".front_image img.logo_img_gal").attr("src");
  var logoaback = $(".back_image img.logo_img_gal").attr("src");
  var backhtml = $(".back_image .cstm_textup").html() || "";
  var fronthtml1 = $(".front_image .cstm_textup").html() || "";
  var backhtml1 = $(".back_image .cstm_textup").html() || "";
  var uploadlogoback = $("#buploaded-image").attr("src");

  if (galtextfront != "" && logoafront != undefined) {
    $(".front_image").addClass("both_textactive");
  }
  if (galtextback != "" && logoaback != undefined) {
    $(".back_image").addClass("both_textactive");
  }
  if (backhtml != "" && uploadlogoback != undefined) {
    $(".back_image").addClass("both_textactive");
  }

  if (sides.front && fronthtml1 != "") {
    $(".front_image .text_uploaded").removeClass("hide").addClass("active");
  }
  if (sides.back && backhtml1 != "") {
    $(".back_image .text_uploaded").removeClass("hide").addClass("active");
  }

  /* Handle logo display for visible sides */
  if (sides.back) {
    var logoback1 = $(".back_image img.logo_img_gal").attr("src");
    if (logoback1 == "" || logoback1 == undefined) {
      $(".back_image .resizable").removeClass("hide").addClass("active");
      $(".back_image .logo_img").addClass("hide").removeClass("active");
      $(".back_image .text_uploaded").removeClass("hide").addClass("active");
    } else {
      $(".back_image .resizable").removeClass("active").addClass("hide");
      $(".back_image .logo_img").addClass("active").removeClass("hide");
      $(".back_image .text_uploaded").removeClass("hide").addClass("active");
    }
  }

  if (sides.front) {
    var logofront1 = $(".front_image img.logo_img_gal").attr("src");
    if (logofront1 == "" || logofront1 == undefined) {
      $(".front_image .resizable").removeClass("hide").addClass("active");
      $(".front_image .logo_img").addClass("hide").removeClass("active");
      $(".front_image .text_uploaded").removeClass("hide").addClass("active");
    } else {
      $(".front_image .resizable").removeClass("active").addClass("hide");
      $(".front_image .logo_img").addClass("active").removeClass("hide");
      $(".front_image .text_uploaded").removeClass("hide").addClass("active");
    }
  }
});

/* ── Outer gallery (Father's Day) preview buttons ──────────────── */
$(document).on("click", ".outergallery_nav_design .preview_btn", function () {
  $(this).addClass("hide");
  $('.outerline').addClass('hide');
  $(".outergallery_nav_design .clear_btn").addClass("hide");
  $(".outergallery_nav_design .addtocart_box").removeClass("hide");
  $('.back_outer.back_btn').addClass('hide');

  /* Hide front/back tabs */
  $(".front_tab").addClass("hide");
  $(".back_tab").addClass("hide");

  /* ── SMART SIDE DETECTION ── */
  var sides = _showSides();

  var galtextback = $(".back_image .cstm_textup").html();
  var galtextfront = $(".front_image .cstm_textup").html();
  var logoafront = $(".front_image img.logo_img_gal").attr("src");
  var logoaback = $(".back_image img.logo_img_gal").attr("src");
  var backhtml = $(".back_image .cstm_textup").html() || "";
  var fronthtml1 = $(".front_image .cstm_textup").html() || "";
  var backhtml1 = $(".back_image .cstm_textup").html() || "";
  var uploadlogoback = $("#buploaded-image").attr("src");

  if (galtextfront != "" && logoafront != undefined) {
    $(".front_image").addClass("both_textactive");
  }
  if (galtextback != "" && logoaback != undefined) {
    $(".back_image").addClass("both_textactive");
  }
  if (backhtml != "" && uploadlogoback != undefined) {
    $(".back_image").addClass("both_textactive");
  }

  if (sides.front && fronthtml1 != "") {
    $(".front_image .text_uploaded").removeClass("hide").addClass("active");
  }
  if (sides.back && backhtml1 != "") {
    $(".back_image .text_uploaded").removeClass("hide").addClass("active");
  }

  /* Handle logo display for visible sides */
  if (sides.back) {
    var logoback1 = $(".back_image img.logo_img_gal").attr("src");
    if (logoback1 == "" || logoback1 == undefined) {
      $(".back_image .resizable").removeClass("hide").addClass("active");
      $(".back_image .logo_img").addClass("hide").removeClass("active");
      $(".back_image .text_uploaded").removeClass("hide").addClass("active");
    } else {
      $(".back_image .resizable").removeClass("active").addClass("hide");
      $(".back_image .logo_img").addClass("active").removeClass("hide");
      $(".back_image .text_uploaded").removeClass("hide").addClass("active");
    }
  }

  if (sides.front) {
    var logofront1 = $(".front_image img.logo_img_gal").attr("src");
    if (logofront1 == "" || logofront1 == undefined) {
      $(".front_image .resizable").removeClass("hide").addClass("active");
      $(".front_image .logo_img").addClass("hide").removeClass("active");
      $(".front_image .text_uploaded").removeClass("hide").addClass("active");
    } else {
      $(".front_image .resizable").removeClass("active").addClass("hide");
      $(".front_image .logo_img").addClass("active").removeClass("hide");
      $(".front_image .text_uploaded").removeClass("hide").addClass("active");
    }
  }
});

/* ── Search handler for gallery inputs ─────────────────────────── */
$(document).ready(function () {
  var galleryMap = {
    animal: '.animal', sports: '.sports', line: '.line', outerline: '.outerline',
    nature: '.nature', weekend: '.weekend', travel: '.travel',
    dog: '.dogs', cat: '.cats', family: '.family', mothersday: '.mothersday'
  };

  $.expr[":"].icontains = function (obj, index, meta) {
    return (obj.textContent || obj.innerText || jQuery(obj).text() || "")
      .toLowerCase().indexOf(meta[3].toLowerCase()) >= 0;
  };

  $(document).on("keyup change", "input[class*='_search']", function () {
    var match = ($(this).attr('class') || '').match(/(\w+)_search/);
    if (!match) return;
    var container = galleryMap[match[1]];
    if (!container) return;
    var term = $(this).val().trim();
    var items = $(container + ' .logo-item-detail');
    if (term.length) {
      items.hide().filter(':icontains(' + term + ')').show();
    } else {
      items.show();
    }
  });
});
